/**
 * The Studio badge for a Create that waits out an outage (Decision 175: notify
 * via a Studio badge until email exists). The Create page marks the game when it
 * shows the waiting screen; the Studio card reads the mark, says "Still working"
 * while the game isn't live and "Ready to play" once it is, and the creator
 * clears it by opening the game. Per browser: a convenience, never authority.
 */
const key = (uid: string) => `djgg:create-waiting:v1:${uid}`;

function read(storage: Storage, uid: string): string[] {
  try {
    const value = JSON.parse(storage.getItem(key(uid)) ?? '[]');
    return Array.isArray(value) ? value.filter((id): id is string => typeof id === 'string').slice(-50) : [];
  } catch { return []; }
}

function write(storage: Storage, uid: string, ids: string[]): void {
  try {
    if (ids.length) storage.setItem(key(uid), JSON.stringify(ids));
    else storage.removeItem(key(uid));
  } catch { /* Storage blocked: the badge just doesn't show. */ }
}

export function markCreateWaiting(storage: Storage, uid: string, creationId: string): void {
  if (!uid) return;
  const ids = read(storage, uid);
  if (!ids.includes(creationId)) write(storage, uid, [...ids, creationId]);
}

export function isCreateWaiting(storage: Storage, uid: string, creationId: string): boolean {
  return Boolean(uid) && read(storage, uid).includes(creationId);
}

export function clearCreateWaiting(storage: Storage, uid: string, creationId: string): void {
  if (!uid) return;
  write(storage, uid, read(storage, uid).filter(id => id !== creationId));
}

/** The badge a Studio card shows for a game whose Create waited, or null. */
export function createWaitingBadge(waiting: boolean, game: { activeVersion: number }): string | null {
  if (!waiting) return null;
  return game.activeVersion > 0 ? 'Ready to play' : 'Still working';
}
